import styled from 'styled-components';

export const VideoFormat = styled.div`
  padding-top: ${({ format }) => {
    switch(format) {
      case '16:9':
        return '56.25%';
      case '1:1':
        return '100%';
      case '4:3':
        return '75%';
      default:
        return '56.25%';
    }
  }};

  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const VideoWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;

  svg {
    width: 120px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  
    path {
      fill: #fff;
    }
  }
`;

export const StyledVideoContainer = styled.img`
  width: 100%;
  height: auto;
  min-height: 100%;
`;